// extracted by mini-css-extract-plugin
export var mt0 = "social-icons-module--mt-0--4027e";
export var mt1 = "social-icons-module--mt-1--b12e9";
export var mt2 = "social-icons-module--mt-2--b6944";
export var mt3 = "social-icons-module--mt-3--03b23";
export var mt4 = "social-icons-module--mt-4--8e3a4";
export var mt5 = "social-icons-module--mt-5--cd922";
export var mt6 = "social-icons-module--mt-6--c3e05";
export var socialIcons = "social-icons-module--social-icons--b77cf";
export var socialIcons__link = "social-icons-module--social-icons__link--d8f0b";
export var socialIcons__link__icon = "social-icons-module--social-icons__link__icon--83354";
export var socialIcons__listItem = "social-icons-module--social-icons__list-item--85458";